<template>
  <section class="solutions-chapter-2">
    <div class="solutions-chapter-2-content">
      <SolutionsAnchorNav :section="2" />

      <v-container class="px-sm-8 py-0 pa-md-0">
        <div>
          <v-row align="start" justify="space-between" no-gutters>
            <v-col cols="12" md="3" lg="3">
              <p class="text-section text--fes-magenta mb-4 mb-md-0">But we’ve come a long way</p>
            </v-col>

            <v-col cols="12" md="8">
              <p class="text-body text--fes-blue mb-12">
                The world has made progress in embracing the global challenge of climate change and sustainable development in recent years. All around the world, policymakers are recognising that social and ecological solutions must work together for any change to be truly sustainable.
              </p>

              <div class="chapter-3-transformation-cards">
                <v-row align="stretch">
                  <v-col cols="12" sm="6" 
                    v-for="n in transformation" 
                    :key="n.icon + '-transformation'" 
                    class="solutions-chapter-2-transformation d-flex">
                    <div>
                      <img :src="require('@/assets/about/chapter3/about-ch3-' + `${n.icon}` + '.svg')" class="mb-6" />
                      <p class="text-card text--fes-blue mb-6">{{ n.title }}</p>
                      <p class="text-body text--fes-blue mb-0" v-html="n.desc" />
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <div class="mt-6 mt-md-0">
                      <p class="text-card text--fes-blue mb-6">The challenge</p>
                      <p class="text-body text--fes-blue mb-6">
                        Measuring progress in this area is tough. International frameworks say little about the specific challenges and solutions cities face. Global inequality makes social-ecological transformation much harder to achieve for some regions.
                      </p>
                      <p class="text-body text--fes-blue mb-0">
                        The Asia-Pacific region’s challenges have led it to make <span><a href="https://www.unescap.org/sites/default/d8files/knowledge-products/ESCAP_Asia_and_the_Pacific_SDG_Progress_Report_2021.pdf#page=22" target="_blank">nearly no progress on SDG 11</a></span> in the past two decades. Cities now produce up to 75 percent of global greenhouse gas emissions, and as the region’s populations and wealth grow, Asia’s cities are looking at big infrastructure projects. This may lock rising emissions into their futures.
                      </p>
                    </div>
                  </v-col>
                </v-row> 
              </div>

            </v-col>
          </v-row>
        </div>    
      </v-container>
    </div>
  </section>  
</template>

<script>
import SolutionsAnchorNav from '@/components/layout/SolutionsAnchorNav'

export default {
  name: 'SolutionsChapter1',
  components: {
    SolutionsAnchorNav
},  
  data() {
    return {
      transformation: [
        { 
          icon: '2030agenda', 
          title: 'UN Sustainable Development Goals',
          desc: 'The <a href="https://sustainabledevelopment.un.org/content/documents/21252030%20Agenda%20for%20Sustainable%20Development%20web.pdf" target="_blank">2030 Agenda for Sustainable Development</a>’s Goal (SDG) 11 includes making cities “inclusive, safe, resilient and sustainable”. From housing and public transportation to environmental governance and citizen participation, SDG 11 calls on cities to integrate environmental and social needs in planning.'
        },
        { 
          icon: 'unhabitat', 
          title: 'UN Habitat New Urban Agenda',
          desc: 'The <a href="https://unhabitat.org/about-us/new-urban-agenda" target="_blank">Agenda</a> first established the “right to the city” approach, which supports the right to just, inclusive, safe, sustainable and democratic cities and settlements. It emphasises local and specific solutions, inclusivity, participatory governance and the consideration of environmental concerns at every level across sectors.'
        },        
        { 
          icon: 'parisagreement', 
          title: 'Paris Agreement',
          desc: 'The <a href="https://unfccc.int/process-and-meetings/the-paris-agreement/the-paris-agreement" target="_blank">Paris Agreement</a> aims to keep global warming below 2 (preferably 1.5) degrees Celsius against pre-industrial levels. It encourages integrating social and economic transformation as countries build climate capacity, developing and sharing climate technology, and committing to long-term emissions reduction. The agreement also recognises the role of non-Party stakeholders, including cities, in addressing climate change.'
        },
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
.solutions-chapter-2 {
  scroll-margin-top: 70px;
}

.solutions-chapter-2-content {
  padding: 96px 0;
  background: #ECF6F9;

  .solutions-chapter-2-transformation:nth-child(-n+2) {
    margin-bottom: 8px;   
  }      

  .solutions-chapter-2-transformation {

    div {
      padding: 32px;
      border: 2px solid #205381;    
    }
  }  
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .solutions-chapter-2-content {
    padding: 48px 4px;
  } 
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .solutions-chapter-2-transformation {
    margin-bottom: 0 !important;
  }

  .solutions-chapter-2-transformation:last-child {
    margin-bottom: unset;   
  }  
}

.solutions-chapter-2-hero {
  img {
    display: block;
  }
}
</style>